import React from 'react';
import { motion } from 'framer-motion';
const stages = [{
  name: 'Vault',
  color: '#CBD5E1',
  description: 'Raw ideas'
}, {
  name: 'Researched',
  color: '#60A5FA',
  description: 'Initial analysis'
}, {
  name: 'Validated',
  color: '#14B8A6',
  description: 'Tested hypothesis'
}, {
  name: 'Active',
  color: '#10B981',
  description: 'Live prototype'
}, {
  name: 'Closed',
  color: '#F59E0B',
  description: 'Post-mortem'
}];
interface PipelineVisualizationProps {
  inView: boolean;
}
export function PipelineVisualization({
  inView
}: PipelineVisualizationProps) {
  return <div className="relative" data-id="element-223">
      <div className="flex flex-col md:flex-row justify-between items-center gap-8 md:gap-4" data-id="element-224">
        {stages.map((stage, index) => <div key={stage.name} className="flex flex-col items-center relative flex-1" data-id="element-225">
            <motion.div initial={{
          scale: 0,
          opacity: 0
        }} animate={inView ? {
          scale: 1,
          opacity: 1
        } : {}} transition={{
          duration: 0.5,
          delay: 0.3 + index * 0.15
        }} className="relative" data-id="element-226">
              <div className="w-24 h-24 rounded-full border-4 flex items-center justify-center relative z-10 bg-[#1F2937]" style={{
            borderColor: stage.color
          }} data-id="element-227">
                <motion.div initial={{
              scale: 0
            }} animate={inView ? {
              scale: [0, 1.2, 1]
            } : {}} transition={{
              duration: 0.6,
              delay: 0.5 + index * 0.15
            }} className="absolute inset-0 rounded-full opacity-20" style={{
              backgroundColor: stage.color
            }} data-id="element-228" />
                <span className="text-2xl font-bold relative z-10" data-id="element-229">
                  {index + 1}
                </span>
              </div>
              <motion.div initial={{
            scale: 0
          }} animate={inView ? {
            scale: 1
          } : {}} transition={{
            duration: 0.8,
            delay: 0.6 + index * 0.15
          }} className="absolute inset-0 rounded-full animate-ping opacity-20" style={{
            backgroundColor: stage.color
          }} data-id="element-230" />
            </motion.div>
            <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={inView ? {
          opacity: 1,
          y: 0
        } : {}} transition={{
          duration: 0.5,
          delay: 0.7 + index * 0.15
        }} className="mt-6 text-center" data-id="element-231">
              <h3 className="text-lg font-bold mb-1" style={{
            color: stage.color
          }} data-id="element-232">
                {stage.name}
              </h3>
              <p className="text-sm text-[#CBD5E1]" data-id="element-233">{stage.description}</p>
            </motion.div>
            {index < stages.length - 1 && <motion.div initial={{
          scaleX: 0
        }} animate={inView ? {
          scaleX: 1
        } : {}} transition={{
          duration: 0.6,
          delay: 0.8 + index * 0.15
        }} className="hidden md:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-gradient-to-r from-[#CBD5E1] to-transparent origin-left" data-id="element-234" />}
          </div>)}
      </div>
    </div>;
}